export default function updateBounds(strokes) {
    if (strokes.length === 0) {
        return null;
    }
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for (const stroke of strokes) {
        const radius = stroke.style.lineWidth / 2;
        for (const point of stroke.points) {
            const x = point.x + stroke.style.offsetX;
            const y = point.y + stroke.style.offsetY;
            minX = Math.min(minX, x - radius);
            minY = Math.min(minY, y - radius);
            maxX = Math.max(maxX, x + radius);
            maxY = Math.max(maxY, y + radius);
        }
    }
    return { minX, minY, maxX, maxY };
}
